import { computed, ref } from "vue";

export const useEventObserver = () => {
  const activeEvents = ref([]);
  const eventCountRef = {};
  const timeoutIds = {};

  const activateEvent = (event) => {
    const currAmount = eventCountRef[event];
    eventCountRef[event] = typeof currAmount === "number" ? currAmount + 1 : 1;

    activeEvents.value = Array.from(new Set([...activeEvents.value, event]));

    clearTimeout(timeoutIds[event]);
    timeoutIds[event] = setTimeout(() => {
      const currActiveEventsSet = new Set(activeEvents.value);
      currActiveEventsSet.delete(event);
      activeEvents.value = Array.from(currActiveEventsSet);
    }, 500);
  };

  const getEventObj = (event) => ({
    active: activeEvents.value.includes(event),
    count: eventCountRef[event] || 0,
  });

  const events = computed(() => ({
    initialized: getEventObj("initialized"),
    destroyed: getEventObj("destroyed"),
    updated: getEventObj("updated"),
    scroll: getEventObj("scroll"),
  }));

  return [events, activateEvent];
};
